import { createReducer } from '@reduxjs/toolkit';

import { StatisticsPartialInit } from 'redux/reducers/init';

import {
  requestStatisticsPartial,
  requestStatisticsPartialSuccess,
  requestStatisticsPartialFailure,
} from 'redux/actions/statistics/actions';

/**
 * Reducers
 */
const statisticsPartial = createReducer(StatisticsPartialInit, {
  [requestStatisticsPartial.type]: (state, action: RequestStatisticsPartialAction) => {
    state.isLoading = true;
  },
  [requestStatisticsPartialSuccess.type]: (
    state,
    action: RequestStatisticsPartialSuccessAction,
  ) => {
    const { statisticsPartial } = action.payload;
    state.isLoading = false;
    state.statistics = statisticsPartial;
  },
  [requestStatisticsPartialFailure.type]: (
    state,
    action: RequestStatisticsPartialFailureAction,
  ) => {
    state.isLoading = false;
    state.statistics = [];
  },
});

export default statisticsPartial;
